import { BadgeV3 } from '@cimplico/components';
import { ArchiveBoxIcon, PaperAirplaneIcon, PencilSquareIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { JournalStatusEnum } from '../../types/journal';

type JournalStatusBadgeProps = {
    status: JournalStatusEnum;
    iconOnly?: boolean;
};

function JournalStatusBadge({ status, iconOnly = false }: JournalStatusBadgeProps): JSX.Element {
    switch (status) {
        case JournalStatusEnum.DRAFT:
            return (
                <BadgeV3
                    color="gray"
                    label={iconOnly ? undefined : 'Draft'}
                    size="small"
                    leftIcon={<PencilSquareIcon className="text-gray-600 " />}
                />
            );
        case JournalStatusEnum.POSTED:
            return (
                <BadgeV3
                    color="green"
                    label={iconOnly ? undefined : 'Posted'}
                    size="small"
                    leftIcon={<PaperAirplaneIcon className="text-green-600 " />}
                />
            );
        case JournalStatusEnum.VOIDED:
            return (
                <BadgeV3
                    color="red"
                    label={iconOnly ? undefined : 'Voided'}
                    size="small"
                    leftIcon={<XMarkIcon className="text-red-600 " />}
                />
            );
        case JournalStatusEnum.ARCHIVED:
            return (
                <BadgeV3
                    color="gray"
                    label={iconOnly ? undefined : 'Archived'}
                    size="small"
                    leftIcon={<ArchiveBoxIcon className="text-gray-600" />}
                />
            );
        default:
            return <></>;
    }
}

export default JournalStatusBadge;
